
	const PATH = '<?= PATH ?>';
	const ADMIN = '<?= ADMIN ?>';




///добавление товара в корзину cj cnhfybws product
const add_to_cart_product = document.querySelectorAll('.add-to-cart-product');
add_to_cart_product.forEach(el => el.addEventListener('click', event => {
	console.log("add_to_cart_product");
	const id = el.getAttribute('data-id');
	//const qty = document.getElementById("add-to-cart-all").value  ? document.getElementById("add-to-cart-all").value : 1;
	const qty = document.getElementById("count_products_text").value  ? document.getElementById("count_products_text").value : 1;
	console.log("id: " + id);
	console.log("qty: " + qty);
	const xhttp = new XMLHttpRequest();
	xhttp.onload = function() {

	}
	xhttp.open("GET", "cart/add?id="+id+"&qty="+qty);
	xhttp.send();
}));








	function add_to_wishlist_category(el){
		event.stopPropagation();
		console.log("add-to-wishlist");
		const id = el.getAttribute('data-id');
		console.log("id: " + id);
		const xhttp = new XMLHttpRequest();
		xhttp.onload = function() {
			const obj = JSON.parse(this.response);
			console.log("obj.qty: " + obj.count)
			console.log("obj: " + obj)
			
			// Проверяем существование элементов перед изменением innerHTML
			const wishlistElement1 = document.getElementById("count-items-wishlist1");
			if (wishlistElement1) {
				wishlistElement1.innerHTML = parseInt(obj.count + 0);
			}
			
			const wishlistFooterElement = document.getElementById("count-items-wishlist-footer");
			if (wishlistFooterElement) {
				wishlistFooterElement.innerHTML = parseInt(obj.count + 0);
			}

			console.log("el.firstChild.firstChild.className: " + el.querySelector(".product__icon-favourites").className )
			if (obj.current){
				el.querySelector(".product__icon-favourites").classList.remove("icon-favourites--active");
			}else {
				el.querySelector(".product__icon-favourites").classList.add("icon-favourites--active");
			}

			if (parseInt(obj.count + 0) > 0){
				document.getElementById("count-items-wishlist_1_p").style.visibility = "visible"
			}else {
				document.getElementById("count-items-wishlist_1_p").style.visibility = "hidden"
			}


		}
		xhttp.open("GET", "wishlist/add?id="+id);
		xhttp.send();
	}




///добавление товара в избранное из списка
const add_to_wishlist = document.querySelectorAll('.add-to-wishlist');
add_to_wishlist.forEach(el => el.addEventListener('click', event => {
	event.stopPropagation();
	console.log("add-to-wishlist");
	const id = el.getAttribute('data-id');
	console.log("id: " + id);
	const xhttp = new XMLHttpRequest();
	xhttp.onload = function() {
		const obj = JSON.parse(this.response);
		console.log("obj.qty: " + obj.count)
		console.log("obj: " + obj)
		
		// Проверяем существование элементов перед изменением innerHTML
		const wishlistElement1 = document.getElementById("count-items-wishlist1");
		if (wishlistElement1) {
			wishlistElement1.innerHTML = parseInt(obj.count + 0);
		}
		
		const wishlistFooterElement = document.getElementById("count-items-wishlist-footer");
		if (wishlistFooterElement) {
			wishlistFooterElement.innerHTML = parseInt(obj.count + 0);
		}

		console.log("el.firstChild.firstChild.className: " + el.querySelector(".product__icon-favourites").className )
		if (obj.current){
			el.querySelector(".product__icon-favourites").classList.remove("icon-favourites--active");
		}else {
			el.querySelector(".product__icon-favourites").classList.add("icon-favourites--active");
		}

		const wishlistCountElement = document.getElementById("count-items-wishlist_1_p");
		if (wishlistCountElement) {
			if (parseInt(obj.count + 0) > 0){
				wishlistCountElement.style.visibility = "visible";
			}else {
				wishlistCountElement.style.visibility = "hidden";
			}
		}


	}
	xhttp.open("GET", "wishlist/add?id="+id);
	xhttp.send();
}));


function add_to_wishlist_function(el){
	console.log("add_to_wishlist");
	const id = el.getAttribute('data-id');
	console.log("id: " + id);
	const xhttp = new XMLHttpRequest();
	xhttp.onload = function() {
		const obj = JSON.parse(this.response);
		console.log("obj.qty: " + obj.count)
		console.log("obj: " + obj)

		document.getElementById("count-items-wishlist1").innerHTML = parseInt(obj.count + 0);
		//document.getElementById("count-items-wishlist2").innerHTML = parseInt(obj.count + 0);
		document.getElementById("count-items-wishlist-footer").innerHTML = parseInt(obj.count + 0);

		if (obj.current){
			el.classList.remove("icon-favourites--active");
		}else {
			el.classList.add("icon-favourites--active");
		}

		if (parseInt(obj.count + 0) > 0){
			document.getElementById("count-items-wishlist_1_p").style.visibility = "visible"
		}else {
			document.getElementById("count-items-wishlist_1_p").style.visibility = "hidden"
		}

	}
	xhttp.open("GET", "wishlist/add?id="+id);
	xhttp.send();
}









///добавление товара в корзину
const add_to_cart = document.querySelectorAll('.add-to-cart');
add_to_cart.forEach(el => el.addEventListener('click', event => {
	console.log("add_to_cart");
	const id = el.getAttribute('data-id');
	//const qty = document.getElementById("add-to-cart-all").value  ? document.getElementById("add-to-cart-all").value : 1;
	const qty = 1;
	console.log("id: " + id);
	console.log("qty: " + qty);
	const xhttp = new XMLHttpRequest();
	xhttp.onload = function() {
		const obj = JSON.parse(this.response);
		
		// Проверяем существование элементов перед изменением innerHTML
		const cartElement = document.getElementById("count-items-cart");
		if (cartElement) {
			cartElement.innerHTML = parseInt(obj.qty + 0);
		}
		
		const headerMenuElement = document.getElementById("header__link-num_bottom_menu");
		if (headerMenuElement) {
			headerMenuElement.innerHTML = parseInt(obj.qty + 0);
		}

		const cartCountElement = document.getElementById("count-items-cart_p");
		if (cartCountElement) {
			if (parseInt(obj.qty + 0) > 0){
				cartCountElement.style.visibility = "visible";
			}else {
				cartCountElement.style.visibility = "hidden";
			}
		}
		
		if (headerMenuElement) {
			if (parseInt(obj.qty + 0) > 0){
				headerMenuElement.style.visibility = "visible";
			}else {
				headerMenuElement.style.visibility = "hidden";
			}
		}

	}
	xhttp.open("GET", "cart/add?id="+id+"&qty="+qty);
	xhttp.send();
}));









///добавление товара в корзину страница категория
const add_to_cart_category_all = document.querySelectorAll('.categorytable__table .add-to-cart');
add_to_cart_category_all.forEach(el => el.addEventListener('click', event => {
	console.log("add_to_cart");
	const id = el.getAttribute('data-id');
	//const qty = document.getElementById("add-to-cart-all").value  ? document.getElementById("add-to-cart-all").value : 1;
	const qty = 1;
	var new_qty = el.parentElement.previousElementSibling.firstElementChild.value
	console.log("new_qty: " + new_qty);
	console.log("id: " + id);
	console.log("qty: " + qty);
	const xhttp = new XMLHttpRequest();
	xhttp.onload = function() {
		const obj = JSON.parse(this.response);
		const qty = document.getElementById("count-items-cart").innerHTML = parseInt(obj.qty + 0);
		const qty2 = document.getElementById("header__link-num_bottom_menu").innerHTML = parseInt(obj.qty + 0);

		if (parseInt(obj.qty + 0) > 0){
			document.getElementById("count-items-cart_p").style.visibility = "visible"
		}else {
			document.getElementById("count-items-cart_p").style.visibility = "hidden"
		}
		if (parseInt(obj.qty + 0) > 0){
			document.getElementById("header__link-num_bottom_menu").style.visibility = "visible"
		}else {
			document.getElementById("header__link-num_bottom_menu").style.visibility = "hidden"
		}


	}
	xhttp.open("GET", "cart/add?id="+id+"&qty="+new_qty);
	xhttp.send();
}));


function add_to_cart_category_function(el){
	console.log("add_to_cart");
	const id = el.getAttribute('data-id');
	//const qty = document.getElementById("add-to-cart-all").value  ? document.getElementById("add-to-cart-all").value : 1;
	const qty = 1;
	var new_qty = el.parentElement.previousElementSibling.firstElementChild.value
	console.log("new_qty: " + new_qty);
	console.log("id: " + id);
	console.log("qty: " + qty);
	const xhttp = new XMLHttpRequest();
	xhttp.onload = function() {
		const obj = JSON.parse(this.response);
		const qty = document.getElementById("count-items-cart").innerHTML = parseInt(obj.qty + 0);
		const qty2 = document.getElementById("header__link-num_bottom_menu").innerHTML = parseInt(obj.qty + 0);
		if (parseInt(obj.qty + 0) > 0){
			document.getElementById("count-items-cart_p").style.visibility = "visible"
		}else {
			document.getElementById("count-items-cart_p").style.visibility = "hidden"
		}
		if (parseInt(obj.qty + 0) > 0){
			document.getElementById("header__link-num_bottom_menu").style.visibility = "visible"
		}else {
			document.getElementById("header__link-num_bottom_menu").style.visibility = "hidden"
		}

	}
	xhttp.open("GET", "cart/add?id="+id+"&qty="+new_qty);
	xhttp.send();
}












///кнопка добавления всех товаров в избранном
if (document.body.contains(document.getElementById("add-to-cart-all"))) {
	console.log("has add-to-cart-all")
	document.getElementById("add-to-cart-all").addEventListener('click', event => {
		console.log("add-to-cart-all");
		const xhttp = new XMLHttpRequest();
		xhttp.onload = function() {
			const obj = JSON.parse(this.response);
			const qty = document.getElementById("count-items-wishlist").innerHTML = obj.count ;
			const qty2 = document.getElementById("count-items-wishlist-footer").innerHTML = obj.count ;
			console.log("parseInt(obj.qty + 0): " + parseInt(obj.qty + 0) )
			document.getElementById("count-items-cart").innerHTML = parseInt(obj.qty + 0);
			document.getElementById("header__link-num_bottom_menu").innerHTML = parseInt(obj.qty + 0);
			document.getElementById("count-items-wishlist").innerHTML = parseInt(0);
			document.getElementById("count-items-wishlist-footer").innerHTML = parseInt(0);
			const element = document.getElementById("wishlist_table");
			element.remove();
			const bascet__info = document.getElementById("bascet__info");
			bascet__info.remove();
			document.getElementById("count-items-wishlist").innerHTML = "0";
			document.getElementById("count-items-wishlist-footer").innerHTML = "0";

		}
		xhttp.open("GET", "wishlist/all?id=0&qty=1");
		xhttp.send();
	});

}else {
	console.log("has not add-to-cart-all")

}








///кнопка очистки избранного

if (document.body.contains(document.getElementById("clear-wishlist-page"))) {
	document.getElementById("clear-wishlist-page").addEventListener('click', event => {
		console.log("clear-wishlist-page");
		const xhttp = new XMLHttpRequest();
		xhttp.onload = function () {
			window.location.reload();
			const element = document.getElementById("wishlist_table");
			element.remove();

			document.getElementById("favourites_count").innerHTML = "0";
			document.getElementById("count-items-wishlist1").innerHTML = "0";
			document.getElementById("count-items-wishlist_1_p").style.visibility = "hidden";
		}
		xhttp.open("GET", "wishlist/clear");
		xhttp.send();
	});
}

///удаление из избранного на странице избранное при нажатии на иконку корзина товара
const delete_from_wishlist = document.querySelectorAll('.delete-from-wishlist');
delete_from_wishlist.forEach(el => el.addEventListener('click', event => {
	console.log("delete_from_wishlist");
	const id = el.getAttribute('data-id');
	console.log("id: " + id);
	var link_name = el.parentElement.parentElement.parentElement.remove();
		const xhttp = new XMLHttpRequest();
		xhttp.onload = function() {
			console.log(JSON.parse(this.response))
			const obj = JSON.parse(this.response);
			const qty = document.getElementById("count-items-wishlist").innerHTML = obj.count ;
			const qty2 = document.getElementById("count-items-wishlist-footer").innerHTML = obj.count ;
			const qty3 = document.getElementById("favourites_count").innerHTML = obj.count + " ";
			const qty4 = document.getElementById("wishlist_total_price").innerHTML = obj.sum;
			const qty5 = document.getElementById("wishlist_total_weigth").innerHTML = obj.weight;
			var link_name = el.parentElement.parentElement.parentElement.remove();

		}
		xhttp.open("GET", "wishlist/delete?id="+id);
		xhttp.send();
}));







function sendrequest2(){

	console.log("sendrequest2")
	document.getElementById("callback2").classList.add('active');
	document.querySelector('.overlow').classList.add('active');
	document.querySelector('body').classList.add('hidden');

}

function addOtziv(name = null, text = null, input_files = null){
	var comment_valedated = true
	if (name.value.length < 2){
		name.style.border = "2px solid #ff0000";
		comment_valedated = false
	}else {
		name.style.border = "2px solid #0dc143";
	}
	if (text.value.length < 2){
		text.style.border = "2px solid #ff0000";
		comment_valedated = false
	}else {
		text.style.border = "2px solid #0dc143";
	}

	var name_value = name.value
	var text_value = text.value
	if (comment_valedated){
		const xhttp = new XMLHttpRequest();
		xhttp.onload = function() {
			console.log(JSON.parse(this.response))
			const obj = JSON.parse(this.response);
			console.log(obj.request)
			if (obj.request){
				document.querySelector('.overlow').classList.add('active');
				document.querySelector('body').classList.add('hidden');
				document.getElementById("callback").classList.add('active');
				document.getElementById("callback2").classList.remove('active');
				document.getElementById("callback").querySelector('.modal__body-text').innerHTML = "Ваш комментарий отправлен на модерацию!"

				text.style.border = "none";
				name.style.border = "2px solid #f6f6f6";
				text.value = ""
				name.value = ""



			}
/*			const obj = JSON.parse(this.response);
			const qty = document.getElementById("count-items-wishlist").innerHTML = obj.count ;
			const qty2 = document.getElementById("count-items-wishlist-footer").innerHTML = obj.count ;
			var link_name = el.parentElement.parentElement.parentElement.remove();*/

		}
		xhttp.open("GET", "comment/add?name="+name_value+"&text="+text_value);
		xhttp.send();
	}

}

function callBack(btn, phone,formname,textarea = "",location = "", input = null, file = null, header = null, name = null, check, formId = null) {//7
	// console.log("phone.length: " + phone.length)
	
	console.log("header:", header)
	let comment = textarea.value;
	console.log('formId: ', formId);

	console.log('------- btn -------', btn);
	console.log('------- phone -------', phone);
	console.log('------- formname -------', formname);
	console.log('------- textarea -------', textarea);
	console.log('------- location -------', location);
	console.log('------- input -------', input);
	console.log('------- file -------', file);
	console.log('------- header -------', header);
	console.log('------- formId -------', formId);
	

	let inputFileLength = 0;
	if (file && file.files) {
		inputFileLength = file.files.length;
	}

	let checkBool = 0;
	if (check) {
		checkBool = check.checked ? 1 : 0;
	}

	event.preventDefault();
	let castomCheck = event.target.closest('.forma').querySelector('.filter__castom-checkbox');
	if (phone.length == 18 && check.checked == true){
		var modalsendrequestcallBack = document.getElementById('callback');
		var overlowcallBack = document.querySelector('.overlow');
		var bodycallBack = document.querySelector('body');
		if (modalsendrequestcallBack) {
			modalsendrequestcallBack.classList.add('show');
			overlowcallBack.classList.add('active');
			bodycallBack.classList.add('hidden');
			document.querySelector('.modalOrderMobile').classList.remove('show')
		}
		input.style.border = "2px solid #E8E8E8";
		input.nextElementSibling.textContent = 'Ожидайте';
		input.nextElementSibling.style.background = '#9cadc3';
		input.nextElementSibling.style.cursor = 'no-drop';
		input.nextElementSibling.disabled = true;

		input.value='';
		textarea.value= '';
		check.checked = false;
		// header = `[2024] Заявка - ${header}`;
		let nameInput = ''
		if (name !== '') {
			nameInput = name.value;
		}

		let chekName = '';
		if (check) {
			chekName = check.checked ? 'Да' : 'Нет';
		}

		var xmlhttp = new XMLHttpRequest();
		if (file == null){
			xmlhttp.onreadystatechange = function() {
				if (xmlhttp.readyState == XMLHttpRequest.DONE) {
					if (xmlhttp.status == 200) {
						console.log("callBack ответ")
						utmFunction1(nameInput, email = null, phone, formId, comment, inputFileLength, checkBool);
						let modal = document.querySelectorAll('.modal');
						modal.forEach(el => {
							el.classList.remove('show');
						});
						let overlow = document.querySelector('.overlow');
						let body = document.querySelector('body');
						let scrollWidth = window.innerWidth;
						const windowWidth = window.innerWidth;

						if ('scrollWidth' in document.body) {
							scrollWidth = document.body.scrollWidth; // width scroll
						}

						const totalScrollWidth = windowWidth - scrollWidth;

						document.querySelector('.notifications').classList.add('show');
						body.style.overflow = 'hidden';
						body.style.paddingRight = `${totalScrollWidth}px`;
						overlow.classList.add('overlow--active');
						console.log("location: " + location)
						if(typeof ym !== 'undefined') {
							if (location == "oformit_zakaz") {
								console.log("reachGoal: oformit_zakaz")
								ym(17351908, 'reachGoal', 'oformit_zakaz');
							} else if (location == "obratniy_zvonok") {
								console.log("reachGoal: obratniy_zvonok")
								ym(17351908, 'reachGoal', 'obratniy_zvonok');
							} else if (location == "pismo_direktoru") {
								console.log("reachGoal: pismo_direktoru")
								ym(17351908, 'reachGoal', 'pismo_direktoru');
							} else if (location == "raschet_smety") {
								console.log("reachGoal: raschet_smety")
								ym(17351908, 'reachGoal', 'raschet_smety');
							} else if (location == "raskladka_plit") {
								console.log("reachGoal: raskladka_plit")
								ym(17351908, 'reachGoal', 'raskladka_plit');
							} else if (location == "kredit_ot_tinkoff") {
								console.log("reachGoal: kredit_ot_tinkoff")
								ym(17351908, 'reachGoal', 'kredit_ot_tinkoff');
							} else if (location == "napisat_pismo") {
								console.log("reachGoal: napisat_pismo")
								ym(17351908, 'reachGoal', 'napisat_pismo');
							} else if (location == "ostavit_otziv_product") {
								console.log("reachGoal: ostavit_otziv_product")
								ym(17351908, 'reachGoal', 'ostavit_otziv_product');
							} else if (location == "zadat_vopros") {
								console.log("reachGoal: zadat_vopros")
								ym(17351908, 'reachGoal', 'zadat_vopros');
							} else if (location == "otziv_o_kompanii") {
								console.log("reachGoal: otziv_o_kompanii")
								ym(17351908, 'reachGoal', 'otziv_o_kompanii');
							} else if (location == "korzina") {
								console.log("reachGoal: korzina")
								ym(17351908, 'reachGoal', 'korzina');
							} else if (location == "smkd") {
								console.log("reachGoal: smkd")
								ym(17351908, 'reachGoal', 'smkd');
							} else if (location == "landing_kupit_pliti_perekritiya") {
								console.log("reachGoal: landing_kupit_pliti_perekritiya")
								ym(17351908, 'reachGoal', 'landing_kupit_pliti_perekritiya')
							} else if (location == 'vn-vr-sinaya') {
								console.log("reachGoal: vn-vr-sinaya");
								ym(17351908,'reachGoal','vn-vr-sinaya');
							} else if (location == 'oformit_zakaz_dostavka') {
								console.log("reachGoal: oformit_zakaz_dostavka");
								ym(17351908,'reachGoal','oformit_zakaz_dostavka');
							}
						}




					}
					else if (xmlhttp.status == 400) {
						alert('error 400');
					}
					else {
						alert(' 200 ');
						document.getElementById("application__form").value;
					}
				}
			};
		}
		console.log("callback?phone=" + phone + "&url=" + window.location.pathname + "&formname=" + formname + "&textarea=" + textarea.value + "&location=" + location + "&header=" + header)
if (file == null){

	xmlhttp.open("GET", "callback?phone=" + phone + "&url=" + window.location.pathname + "&formname=" + formname + "&textarea=" + comment + "&location=" + location + "&header=" + header + "&name=" + name.value + "&check_name=" + chekName, "&header=" + header, true);
	xmlhttp.send();
	textarea.value = '';
	if (name) name.value = '';
	if (event.target.closest('.forma').querySelector('.filter__castom-checkbox')) {
		castomCheck.style.borderColor = '#ddd';
		castomCheck.nextElementSibling.style.color = '#474747';
		if (btn.closest('.forma').querySelector('.catalogform__checkbox-text')) {
			if (!btn.closest('.forma').querySelector('.catalogform__checkbox-text').classList.contains('.catalogform__checkbox-text')) {
				btn.closest('.forma').querySelector('.catalogform__checkbox-text').style.color = '#fff'
			}
		}

		if (btn.closest('.forma').querySelector('.catalogform__input')) {
			if (!btn.closest('.forma').querySelector('.catalogform__input').classList.contains('.catalogform__input')) {
				btn.closest('.forma').querySelector('.catalogform__input').style.borderRadius = '6px';
			}
		}


	}
	if (check) check.checked = false;

}else {
	console.log("has file:" + file)
	let data = new FormData();
	data.append('phone', phone);
	data.append('email', window.location.pathname);
	/*data.append('name', formname);*/
	data.append('text', comment);
	data.append('location', location);
	data.append('header', header);
	/*data.append('myfile', file);*/

	if (file.files.length > 0) {
		data.append('myfile', file.files[0]);
	}
	data.append('name', name.value);
	data.append('check_name', chekName);
	xmlhttp.open('POST', '/callbackdraft', true);
	xmlhttp.onload = function () {
		// do something to response
		console.log(this.responseText);
		
		document.querySelector('.formadelivery').classList.remove('show');
		utmFunction1(nameInput, email = null, phone, formId, comment, inputFileLength, checkBool);
	};
	xmlhttp.send(data);


}
	}else {
		if (input.value.length === 18) {
			input.style.border = "2px solid #E8E8E8";
			input.nextElementSibling.disabled = false;
			if (btn.closest('.forma').querySelector('.catalogform__input')) {
				if (!btn.closest('.forma').querySelector('.catalogform__input').classList.contains('.catalogform__input')) {
					btn.closest('.forma').querySelector('.catalogform__input').style.border = '2px solid transparent';
				}
			}
		} else {
			input.style.border = "2px solid #ff0000";
		}
		if (event.target.closest('.forma').querySelector('.filter__castom-checkbox')) {
			if (!check.checked) {
				castomCheck.style.borderColor = '#ff0000';
				castomCheck.nextElementSibling.style.color = '#ff0000';
				if (btn.closest('.forma').querySelector('.catalogform__checkbox-text')) {
					if (!btn.closest('.forma').querySelector('.catalogform__checkbox-text').classList.contains('.catalogform__checkbox-text')) {
						btn.closest('.forma').querySelector('.catalogform__checkbox-text').style.color = '#ff0000'
					}
				}
				if (btn.closest('.forma').querySelector('.catalogform__input')) {
					if (!btn.closest('.forma').querySelector('.catalogform__input').classList.contains('.catalogform__input')) {
						btn.closest('.forma').querySelector('.catalogform__input').style.borderRadius = '6px';
					}
				}
			} else {
				castomCheck.style.borderColor = '#ddd'
				castomCheck.nextElementSibling.style.color = '#474747';
				if (btn.closest('.forma').querySelector('.catalogform__checkbox-text')) {
					if (!btn.closest('.forma').querySelector('.catalogform__checkbox-text').classList.contains('.catalogform__checkbox-text')) {
						btn.closest('.forma').querySelector('.catalogform__checkbox-text').style.color = '#fff';
					}
				}
				if (btn.closest('.forma').querySelector('.catalogform__input')) {
					if (!btn.closest('.forma').querySelector('.catalogform__input').classList.contains('.catalogform__input')) {
						btn.closest('.forma').querySelector('.catalogform__input').style.border = '2px solid transparent';
					}
				}
			}
		}

	}
}

// Делаем функцию callBack глобально доступной
window.callBack = callBack;



	


	

	function callBackDiractor() {
		var xmlhttp = new XMLHttpRequest();
		var name = document.getElementById("modalletterdirection-input-name").value
		var mail = document.getElementById("modalletterdirection-input-mail").value
		var textarea = document.getElementById("modalletterdirection-textarea-text").value
		var code = document.getElementById("modalletterdirection-code-text").value
		var checkbox = document.getElementById("dicrector-checkbox").checked
		const formId = document.querySelector('.saydirector').querySelector('form');

		let checkBool1 = 0;
		if (checkbox) {
			checkBool1 = checkbox === true ? 1 : 0;
		}
		
		if (checkbox){
			xmlhttp.onreadystatechange = function() {
				if (xmlhttp.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
					if (xmlhttp.status == 200) {
						console.log("callBackDiractor ответ")
						utmFunction1(name, mail, null, formId.dataset.formId, textarea, null, checkBool1);
						var data = xmlhttp.responseText;
						/*	const txt = '{"phone":"'+phone+'","mail":"'+mail+'","textarea":"'+textarea+'","code":"'+code+'"}'
                            const obj = JSON.parse(txt);*/
						var jsonResponse = JSON.parse(data);
						console.log(jsonResponse)
						let modalletterDirection = document.getElementById('modalletterDirection');
						console.log("modalletterDirection")
						console.log("modalletterDirection")

						ym(17351908, 'reachGoal', 'pismo_direktoru');


						modalletterDirection.classList.remove("show");
						modalletterDirection.remove();
						modalletterDirection.className = "modal saydirector modalWindow";

						console.log(modalletterDirection.className)



						document.querySelector('.overlow').classList.remove('active');
						document.querySelector('body').classList.remove('hidden');


						let modalsendrequestcallBack = document.getElementById('callback');
						let overlowcallBack = document.querySelector('.overlow');
						let bodycallBack = document.querySelector('body');
						if (modalsendrequestcallBack) {
							modalsendrequestcallBack.classList.add('active');
							overlowcallBack.classList.add('active');
							bodycallBack.classList.add('hidden');

						}
						let modal = document.querySelectorAll('.modal');
						modal.forEach(el => {
							el.classList.remove('show');
						});
						let overlow = document.querySelector('.overlow');
						let body = document.querySelector('body');
						document.querySelector('.notifications').classList.add('show');
						body.style.overflow = 'hidden';
						overlow.classList.add('overlow--active');

						document.querySelector('#modalletterDirection').classList.remove('show');
					}
					else if (xmlhttp.status == 400) {
						alert('error 400');
					}
					else {
						//alert(' 200 ');
						document.getElementById("application__form").value;
					}
				}
			};
			xmlhttp.open("GET", "callbackdirector?mail=" + mail + "&textarea=" + textarea + "&name=" + name + "&code=" + code + "&url=" + window.location.pathname , true);
			xmlhttp.send();

			let modal = document.querySelectorAll('.modal');
			modal.forEach(el => {
				el.classList.remove('show');
			});
		}else {
			alert("Галка не стоит")
		}
	}


function callBackModalFooter(value = null) {
	var xmlhttp = new XMLHttpRequest();
	var phone = value;
	if (value == null) {
		phone = document.getElementById("application-form-phone-modal-footer").value
	}

	xmlhttp.onreadystatechange = function() {
		if (xmlhttp.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
			if (xmlhttp.status == 200) {

				console.log("callBackModalFooter ответ")
				var data = xmlhttp.responseText;
				console.log(data)
				var jsonResponse = JSON.parse(data);
				console.log(jsonResponse)

				document.getElementById("callback2").classList.remove('active');
				document.querySelector('.overlow').classList.remove('active');
				document.querySelector('body').classList.remove('hidden');

				document.querySelector('.overlow').classList.add('active');
				document.querySelector('body').classList.add('hidden');
				document.getElementById("callback").classList.add('active');

			}
			else if (xmlhttp.status == 400) {
				alert('error 400');
			}
			else {
				alert(' 200 ');
				document.getElementById("application__form").value;
			}
		}
	};
	console.log("callback?phone=" + phone)
	xmlhttp.open("GET", "callback?phone=" + phone, true);
	xmlhttp.send();
}







function callBackDraftModul() {
	var xmlhttp = new XMLHttpRequest();
	var name = document.getElementById("draft_modul_name").value
	var phone = document.getElementById("draft_modul_phone").value
	var file = document.getElementById("draft_modul_file").value

	xmlhttp.onreadystatechange = function() {
		if (xmlhttp.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
			if (xmlhttp.status == 200) {
				console.log("callBack ответ")
				var data = xmlhttp.responseText;
				var jsonResponse = JSON.parse(phone);
				console.log(jsonResponse)

				document.getElementById("attachadrawing").classList.remove('active');
				document.querySelector('.overlow').classList.add('active');
				document.querySelector('body').classList.add('hidden');
				document.getElementById("callback").classList.add('active');


			}
			else if (xmlhttp.status == 400) {
				alert('error 400');
			}
			else {
				alert(' 200 ');
				document.getElementById("application__form").value;
			}
		}
	};

	var text_request = "phone=" + phone + "&name=" + name + "&file=" + file
	console.log(text_request)

	xmlhttp.open("GET", "callbackdraftmodul?" + text_request, true);
	xmlhttp.send();
}










function callBackGroup() {
	alert("callBackGroup");

	document.querySelectorAll('.modal').forEach(element => {
		element.classList.remove('active');
		document.querySelector('.overlow').classList.remove('active');
	});
	var xmlhttp = new XMLHttpRequest();
	var phone = document.getElementById("application-form-phone-group").value

	xmlhttp.onreadystatechange = function() {
		if (xmlhttp.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
			if (xmlhttp.status == 200) {
				console.log("callBack ответ")
				var data = xmlhttp.responseText;
				var jsonResponse = JSON.parse(phone);
				console.log(jsonResponse)
			}
			else if (xmlhttp.status == 400) {
				alert('error 400');
			}
			else {
				alert(' 200 ');
				document.getElementById("application__form").value;
			}
		}
	};
	xmlhttp.open("GET", "callback?phone=" + phone, true);
	xmlhttp.send();
}



	let page_count = 1;

function sort_click(more = false) {

	if (more) {
		++page_count;
	}
	if (more && page_count == 2) {
		//++page_count;
	}
	console.log("page_count: " + page_count + "")

	document.getElementById("div_of_count").style.visibility = ""
	document.getElementById("div_of_count").style.position = ""

	sort_small_path_names = '';
	sort_map = new Map();

	var sort_small = document.getElementsByClassName("sort_small");
	var sort_small2 = document.getElementsByClassName("sort_small");

	for(var i = 0; i < sort_small.length; i++)
	{
		if (document.getElementById("count_" + sort_small[i].name)) {
			document.getElementById("count_" + sort_small[i].name).innerHTML = "0"
			document.getElementById("count_" + sort_small[i].name).style.visibility = "relative"
			console.log("count_")
		}
	}
	document.getElementById("bottom_filter").innerHTML = ""

	for(var i = 0; i < sort_small.length; i++)
	{



		//console.log("name: " + sort_small[i].name + " - "+ sort_small[i].value + "&");
		if (sort_small[i].value.length > 0 && sort_small[i].checked){



			if (sort_map.get(sort_small[i].name)){
				sort_map.set(sort_small[i].name, sort_map.get(sort_small[i].name) + "," + sort_small[i].value);
				document.getElementById("count_" + sort_small[i].name).innerHTML = parseInt(document.getElementById("count_" + sort_small[i].name).innerHTML) + 1
				document.getElementById("count_" + sort_small[i].name).style.visibility = "visible"
			}else {
				sort_map.set(sort_small[i].name, sort_small[i].value);
				document.getElementById("count_" + sort_small[i].name).innerHTML = 1
				document.getElementById("count_" + sort_small[i].name).style.visibility = "visible"
			}



			if (sort_small_path_names == ''){
				sort_small_path_names += "?" + sort_small[i].name + "=" + sort_small[i].value
			}else {

				if (sort_small_path_names.indexOf(sort_small[i].name)){

					console.log("sort_small_path_names")
					console.log(sort_small_path_names.slice(0, sort_small_path_names.lastIndexOf(sort_small[i].name)))
					console.log(sort_small_path_names.slice(sort_small_path_names.lastIndexOf(sort_small[i].name)))
					console.log("sort_small_path_names")
					sort_small_path_names =
						sort_small_path_names.slice(0, sort_small_path_names.lastIndexOf(sort_small[i].name))  +
						sort_small_path_names.slice(sort_small_path_names.lastIndexOf(sort_small[i].name))+","+ sort_small[i].value

				}else {
					sort_small_path_names += "&" + sort_small[i].name + "=" + sort_small[i].value

					sort_small_path_names = sort_small_path_names.replace("&&","&")
				}
			}




			let para = document.createElement("p");
			para.className = "filter__quickfilter-tag categories__filter-bottom--tag"

			let russian_name = ""
			switch (sort_small[i].name) {
				case 'length':
					 russian_name = "Длина(L), мм"
					break;
				case 'width':
					 russian_name = "Ширина(B), мм"
					break;
				case 'height':
					 russian_name = "Высота(H), мм"
					break;
				case 'diameter_inner':
					 russian_name = "Диаметр внутренний, мм"
					break;
				case 'diameter_outer':
					 russian_name = "Диаметр внешний, мм"
					break;
				case 'volume':
					 russian_name = "Обьем бетона, м³"
					break;
				case 'weight':
					 russian_name = "Вес 1 шт., т"
					break;
				case 'weight_kg_m_p':
					 russian_name = "Вес, в кг метра погонного"
					break;
				case 'glubina_zaleganiya':
					 russian_name = "Глубина залегания, мм"
					break;
				case 'load_kg':
					 russian_name = "Расчетная нагрузка, тонн"
					break;
				case 'diameter_inner':
					 russian_name = "Диаметр внутренний, мм"
					break;
				case 'diameter_outer':
					 russian_name = "Диаметр внешний, мм"
					break;
				case 'volume':
					 russian_name = "Обьем бетона, м³"
					break;
				case 'tolshina_stenki':
					 russian_name = "Толщина стенки t, мм"
					break;
				case 'class_gestkosti':
					 russian_name = "Класс жесткости"
					break;
				case 'dlina_buhti':
					 russian_name = "Длина бухты, мм"
					break;
				case 'vnesh_diameter_buhti':
					 russian_name = "Внешний диаметр бухты, мм"
					break;
				case 'vnut_diameter_buhti':
					 russian_name = "Внутренний диаметр бухты, мм"
					break;
				case 'visota_buhti':
					 russian_name = "Вес 1 шт., т"
					break;
				case 'ves_buhti':
					 russian_name = "Вес бухты, кг"
					break;
				case 'gost':
					 russian_name = "Технические условия"
					break;
				case 'marka_betona':
					 russian_name = "Класс бетона по прочности"
					break;
				default:
					russian_name = sort_small[i].name

			}

			para.innerHTML = "<span data-value='"+sort_small[i].value+"' data-name='"+sort_small[i].name+"' value='"+sort_small[i].value+"'>"+russian_name+": "+sort_small[i].value+"</span>"
			let ss = sort_small[i]

			document.getElementById("bottom_filter").append(para)

			para.onclick = function (n,v) {
				for(var i = 0; i < sort_small2.length; i++)				{
					if (this.firstChild.getAttribute("data-name") == sort_small2[i].name && this.firstChild.getAttribute("data-value") == sort_small2[i].value) {
						sort_small2[i].checked = false
						sort_click()
					}
				}
				this.remove(this);
			};

		}
	}


	if (document.getElementById("bottom_filter").innerHTML.length > 10){
		let div = document.createElement("div");
		div.className = "filter__quickfilter-tag categories__filter-bottom--tag"
		div.innerHTML = "<div class=\"filter__quickfilter-tag categories__filter-bottom--tag\">\n" +
			"                                    <span>Сбросить всё</span>\n" +
			"                                </div>"

		document.getElementById("bottom_filter").append(div)
		div.onclick = function (n,v) {
			for(var i = 0; i < sort_small2.length; i++)				{
					sort_small2[i].checked = false
			}
			sort_click()
			this.remove(this);
			document.getElementById("div_of_count").style.position = "absolute"

		};
	}









	console.log("sort_map")
	console.log(sort_map)
	console.log("sort_map")


	let sort_map_string = "?"
	sort_map.forEach((values, keys) => {
		sort_map_string += keys + "=" + values +"&"
	})

	console.log(sort_map_string)





	var table_search = document.getElementById("table_name").value;
	if (table_search.length > 1){
		console.log("table_search.length > 1")
		if (sort_small_path_names == ''){
			sort_small_path_names += "?name=" + table_search
		}else {
			sort_small_path_names += "&name=" + table_search
		}

		if (sort_map_string == ''){
			sort_map_string += "?name=" + table_search
		}else {
			sort_map_string += "&name=" + table_search
		}
	}


	sort_small_path_names +=  "&" + document.getElementById("input-sort-popular").value +"&slug=" +  (window.location.pathname.split("/"))[3]
	if (sort_map_string == "?") {
		sort_map_string +=  "slug=" + (window.location.pathname.split("/"))[3]
	}else {
		sort_map_string +=  "&slug=" + (window.location.pathname.split("/"))[3]
	}

	sort_small_path_names = sort_small_path_names.replace("&&","&")
	sort_map_string = sort_map_string.replace("&&","&")
	//alert(sort_small_path_names)
	console.log("sort_small_path_names1")
	console.log(sort_small_path_names)
	console.log("sort_map_string:")
	console.log(sort_map_string)

	sort_map_string +=  "&page=" + page_count + "&count_to_show=" + document.getElementById("count_to_show").innerHTML



	loadXMLDoc(sort_map_string, more)


}




//сортировка товаров для страницы категория
function sort_category(paramet, name) {
	//alert(paramet)
	document.getElementById("input-sort-popular").value = paramet
	document.getElementById("input-sort-popular").innerHTML = name

	sort_click()
	if (window.location.pathname.includes("?")){

		//  window.location = PATH + window.location.pathname + '&' + paramet;
	}else {
		// window.location = PATH + window.location.pathname + '?' + paramet;
	}
}




function loadXMLDoc(sort_small_path_names, more = false) {
	var xmlhttp = new XMLHttpRequest();

	xmlhttp.onreadystatechange = function() {
		if (xmlhttp.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
			if (xmlhttp.status == 200) {
				console.log("ответ")
				//console.log(xmlhttp.responseText) ;
				var data = xmlhttp.responseText;
				var jsonResponse = JSON.parse(data);

				console.log("more:" + more)
				console.log("jsonResponse[result]:" + jsonResponse["result"])

				if (jsonResponse["result"] != "false") {
					if (more) {
						document.getElementById("categorytable__table-body").insertAdjacentHTML('beforeend', jsonResponse["sort_category"]);
						document.getElementById("categorytable__table-body2").insertAdjacentHTML('beforeend', jsonResponse["sort_category2"]);
						document.getElementById("categorytable__table-body3").insertAdjacentHTML('beforeend', jsonResponse["sort_category3"]);
					} else {
						while (document.getElementById("categorytable__table-body").children.length > 0) {
							document.getElementById("categorytable__table-body").removeChild(document.getElementById("categorytable__table-body").lastChild);
						}
						while (document.getElementById("categorytable__table-body2").children.length > 0) {
							document.getElementById("categorytable__table-body2").removeChild(document.getElementById("categorytable__table-body2").lastChild);
						}
						while (document.getElementById("categorytable__table-body3").children.length > 0) {
							document.getElementById("categorytable__table-body3").removeChild(document.getElementById("categorytable__table-body3").lastChild);
						}

						document.getElementById("categorytable__table-body").insertAdjacentHTML('beforeend', jsonResponse["sort_category"]);
						document.getElementById("categorytable__table-body2").insertAdjacentHTML('beforeend', jsonResponse["sort_category2"]);
						document.getElementById("categorytable__table-body3").insertAdjacentHTML('beforeend', jsonResponse["sort_category3"]);
					}

					const lazyMedia = document.querySelectorAll(".lazy-images");
					const observer = new IntersectionObserver((entries, observer) => {
						entries.forEach((entry) => {
							if (entry.isIntersecting) {
								// Получаем целевой элемент
								const media = entry.target;

								if (media.tagName === "VIDEO") {
									// Если это видео
									const source = media.querySelector("source");
									console.log("Video", source);
									if (source && source.dataset.src) {
										source.src = source.dataset.src; // Устанавливаем src источника видео
										media.load();
									}
								} else if (
									media.tagName === "IMG" || media.querySelector("img")
								) {
									// Если это изображение или picture
									const img = media.querySelector("img"); // Получаем img внутри picture
									console.log(media);
									console.log(img.dataset.src);
									if (img && img.dataset.src) {
										img.src = img.dataset.src; // Устанавливаем src изображения

										// Удаляем скелетон после загрузки изображения
										const skeletonContainer = img.closest('.lazy-images');
										if (skeletonContainer && skeletonContainer.querySelector('.skeleton-img')) {
											skeletonContainer.querySelector('.skeleton-img').remove();
										}
									}

								}
								observer.unobserve(media);
							}
						});
					});

					lazyMedia.forEach((media) => {
						observer.observe(media);
					});
				}else {
					let categories_btn = document.querySelector(".categories__content-footer--btn")
					if (categories_btn)categories_btn.style.visibility = "hidden"
				}



				document.getElementById("count_products").innerHTML = jsonResponse["total_products"] + " товаров";
				//document.getElementById("show_products").innerHTML = jsonResponse["perpage"];


			}
			else if (xmlhttp.status == 400) {
				alert('error 400');
			}
			else {
				alert(' 200 ');
			}
		}
	};
	var location = PATH + window.location.pathname

	console.log("sort_small_path_names3")
	console.log(sort_small_path_names)
	xmlhttp.open("GET", "sort/category" + sort_small_path_names, true);
	xmlhttp.send();
}




	///маска для телефона на чистом javascript
	window.addEventListener("DOMContentLoaded", function() {
	var tel = document.getElementById('productform-phone');
	[].forEach.call( document.querySelectorAll('.productform-phone'), function(input) {
	var keyCode;
	function mask(event) {
	event.keyCode && (keyCode = event.keyCode);
	var pos = this.selectionStart;
	//if (pos < 3) event.preventDefault();
	console.log(this.value);
	let valInput = this.value;
	if(valInput == "+_9") {
	this.value = "+7 (9";
	return false;
}
	if(valInput == "+_") {
	this.value = "+";
	return false;
}
	if(valInput == "+") {
	this.value = "+";
	return false;
}
	if(valInput == "") {
	this.value = "+";
	return false;
}

	var matrix = "+_ (___) ___-__-__",
	i = 0,
	def = matrix.replace(/\D/g, ""),
	val = this.value.replace(/\D/g, ""),
	new_value = matrix.replace(/[_\d]/g, function(a) {
	return i < val.length ? val.charAt(i++) || def.charAt(i) : a
});
	i = new_value.indexOf("_");
	if (i != -1) {
	i < 5 && (i = 2);
	new_value = new_value.slice(0, i)
}
	var reg = matrix.substr(0, this.value.length).replace(/_+/g,
	function(a) {
	return "\\d{1," + a.length + "}"
}).replace(/[+()]/g, "\\$&");
	reg = new RegExp("^" + reg + "$");
	if (!reg.test(this.value) || this.value.length < 5 || keyCode > 47 && keyCode < 58) this.value = new_value;
	if (event.type == "blur" && this.value.length < 5)  this.value = "";

	if(valInput == "+_") {
	this.value = "+";
	return false;
}
}

	input.addEventListener("input", mask, false);
	input.addEventListener("focus", mask, false);
	input.addEventListener("blur", mask, false);
	input.addEventListener("keydown", mask, false)
	input.addEventListener("click", mask, false)

});

});
///маска для телефона на чистом javascript


// modal tinkoff
function tinkoff(){
	document.getElementById('modalTin').classList.add('active')
	document.querySelector('.overlow').classList.add('active');
	document.querySelector('body').classList.add('hidden')
}


function tinkoffSend(phone, name, location = "") {
/*	var phone = document.getElementById('tincoff-phone').value;
	var name = document.getElementById('tincoff-name').value;*/
	var btnTin = document.querySelectorAll('.aboutproduct__card');


	if (phone.value.length == 18){
		phone.style.border = "1px solid #E8E8E8";
	}else {
		phone.style.border = "2px solid #ff0000";
	}

	if (name.value.length > 1){
		name.style.border = "1px solid #E8E8E8";
	}else {
		name.style.border = "2px solid #ff0000";
	}
	if (name.value.length > 1 && phone.value.length == 18){
		var xmlhttp = new XMLHttpRequest();
		xmlhttp.onreadystatechange = function() {
			if (xmlhttp.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
				if (xmlhttp.status == 200) {
					console.log("calltincoff ответ")

					document.getElementById('modalTin').classList.remove('active')
					document.querySelector('.overlow').classList.add('active');
					document.querySelector('body').classList.add('hidden');
					document.getElementById("callback").classList.add('active');
				}
				else if (xmlhttp.status == 400) {
					alert('error 400');
				}
				else {
					alert(' 200 ');
					document.getElementById("application__form").value;
				}
			}
		};
		console.log("calltincoff?phone=" + phone.value + "&name=" + name.value + "&url=" + window.location.pathname + "&location=" + location)
		xmlhttp.open("GET", "calltincoff?phone=" + phone.value + "&name=" + name.value + "&url=" + window.location.pathname + "&location=" + location, true);
		xmlhttp.send();
	}




}

// // modal tinkoff



	
	
	
	
	
	
	
	
	
	
	
	